import type { CreditBalance, CreditHistoryResponse } from '@eloquor/api-contract';
import { apiFetch } from './client';

export async function getMyBalance(): Promise<CreditBalance> {
  return apiFetch<CreditBalance>('/credits/me');
}

export async function getMyHistory(): Promise<CreditHistoryResponse> {
  return apiFetch<CreditHistoryResponse>('/credits/me/history');
}
